import AdminUsers from './admin';
import ClientUsers from './client';

const tenants = {
    admin: AdminUsers,
    client: ClientUsers
};

export default tenants;



// WEBPACK FOOTER //
// ./src/pages/users/tenants/index.jsx